<template>
  <div class="breadcrumb-separator">
    <span class="material-icons">chevron_right</span>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.breadcrumb-separator {
  display: flex;
  align-items: center;
  padding: 0 10px;
  color: #7f8ea6;
  font-weight: 600;
  font-size: 22px;
}
</style>
